import { Component, computed, inject, input, Input, ChangeDetectionStrategy } from '@angular/core';

import { TextHtmlComponent } from '@sirius/common';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { InterpolatePipe } from 'shared/pipes';

@Component({
    selector: 'matchmaking-result-page-header',
    imports: [InterpolatePipe, TextHtmlComponent],
    templateUrl: './result-page-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './result-page-header.component.scss'
})
export class ResultPageHeaderComponent {
    translateService = inject(MatchmakingTranslateService);

    userName = input.required<string>();

    translations = computed(() => this.translateService.translations());
}
